"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UniqueIdGeneratorContextProvider = exports.useUniqueIdGenerator = void 0;

var _react = require("react");

var defaultUniqueIdGenerator = function () {
  var nextValue = 0;
  return function () {
    return "i".concat(nextValue++);
  };
}();

var context = /*#__PURE__*/(0, _react.createContext)(defaultUniqueIdGenerator);

var useUniqueIdGenerator = function useUniqueIdGenerator() {
  return (0, _react.useContext)(context);
};

exports.useUniqueIdGenerator = useUniqueIdGenerator;
var UniqueIdGeneratorContextProvider = context.Provider;
exports.UniqueIdGeneratorContextProvider = UniqueIdGeneratorContextProvider;